<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-img
            class="tenant-logo"
            id="menu-tenant-logo"
            [src]="tenantConfig.logoUrl"
            [ngStyle]="tenantConfig.tenantName === 'BestBau' ? { width: '70%', 'margin-left': '5%' } : {}"
            alt="{{ tenantConfig.tenantName || 'Tenant Logo' }}"
          ></ion-img>

          <ion-list-header style="padding-top: 25px; padding-bottom: 10px"> Kalkulatoren </ion-list-header>

          @for (p of filteredAppPages; track p; let i = $index) {
          <ion-menu-toggle auto-hide="false">
            <ion-item
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
              [disabled]="p.disabled"
            >
              <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          }

          <ion-list-header style="padding-top: 10px; padding-bottom: 10px"> Projekte </ion-list-header>

          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" routerLink="/projects" lines="none" detail="false" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" ios="calculator-outline" md="calculator-sharp"></ion-icon>
              <ion-label>Photovoltaik</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-list-header style="padding-top: 10px; padding-bottom: 10px"> Informationen </ion-list-header>

          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" routerLink="/information" lines="none" detail="false" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" ios="help-outline" md="help-sharp"></ion-icon>
              <ion-label>Photovoltaik</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-list-header style="padding-top: 10px; padding-bottom: 10px"> Einstellungen </ion-list-header>

          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="[settingsPage?.url]" lines="none" detail="false" routerLinkActive="selected">
              <ion-icon
                aria-hidden="true"
                slot="start"
                [ios]="settingsPage?.icon + '-outline'"
                [md]="settingsPage?.icon + '-sharp'"
              ></ion-icon>
              <ion-label>{{ settingsPage?.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
